import React from 'react';

const modalStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '90vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  marginTop: '70px',
};

const imageStyle = {
  maxWidth: '90vw',
  maxHeight: '80vh',
  boxShadow: '0 0 20px #000',
  cursor: `url('data:image/svg+xml;utf8,<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><circle cx="7" cy="7" r="6" stroke="black" stroke-width="1" fill="white"/><rect x="4" y="6.5" width="6" height="1" fill="black"/><line x1="11" y1="11" x2="15" y2="15" stroke="black" stroke-width="1"/></svg>') 8 8, zoom-out`,
};

export default function ZoomModal({ open, imageUrl, onClose }) {
  if (!open) return null;
  return (
    <div style={modalStyle} onClick={onClose}>
      <img src={imageUrl} alt="Zoomed" style={imageStyle} />
    </div>
  );
}
